import {DefaultWellValue} from 'constants/dataEnum';
import {DEFAULT_OTHER_PLATE_LABEL, PlateProperties, WellLabel} from './PlateTypeEditorEnum';

export const getPlateName = (plate) => {
  switch (plate) {
    case WellLabel.WELL_SPEAR_BIO:
      return 'Spear Bio Plate';
    default:
      return `IFC ${plate}`;
  }
};

export const getWellSelectionLabel = (wellLabel) => {
  switch (wellLabel) {
    case WellLabel.WELL_SPEAR_BIO:
      return 'Spear Bio Plate';
    case WellLabel.WELL_IFC_192_24:
    case WellLabel.WELL_IFC_96_96:
    case WellLabel.WELL_IFC_48_48:
      return `IFC ${wellLabel}`;
    default:
      return DEFAULT_OTHER_PLATE_LABEL;
  }
};

export const getMicroplateLabel = (wellLabel) => {
  switch (wellLabel) {
    case WellLabel.WELL_24:
      return '24';
    case WellLabel.WELL_48:
      return '48';
    default:
      return wellLabel;
  }
};

export const getPlatePropertyPlaceholder = (label, wellLabel) => {
  switch (label) {
    case PlateProperties.ROW_PITCH:
      if (wellLabel === WellLabel.WELL_24) return DefaultWellValue.WELL_24.rowPitch;
      if (wellLabel === WellLabel.WELL_48) return DefaultWellValue.WELL_48.rowPitch;
      return '';
    case PlateProperties.COLUMN_PITCH:
      if (wellLabel === WellLabel.WELL_24) return DefaultWellValue.WELL_24.columnPitch;
      if (wellLabel === WellLabel.WELL_48) return DefaultWellValue.WELL_48.columnPitch;
      return '';
    default:
      return '';
  }
};
